import { render, staticRenderFns } from "./BaseError.vue?vue&type=template&id=17d44ff4&"
import script from "./BaseError.vue?vue&type=script&lang=js&"
export * from "./BaseError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports